import classes from "../../../styles/Modal.module.css";
import { getClasses } from "../../../utils";
import { useTranslation, useCustomImage } from "../../../hooks";

const BonusCard: React.FC<{
  bonusId: string;
  name: string;
  description: string;
  image: string;
  onClick?: (bonus: string) => any;
}> = ({ bonusId, name, description, image, onClick }) => {
  const bg = useCustomImage(image);
  const style = bg ? { backgroundImage: `url(${bg}) ` } : {};
  const _onClick = onClick ? onClick.bind(null, bonusId) : () => {};
  const clickableClass = onClick ? "clickable" : "";

  return (
    <div
      className={getClasses(classes, "bonus-card", "small", clickableClass)}
      onClick={_onClick}
    >
      <div className={classes["header-image-wrapper"]}>
        <div className={classes["header-image"]} style={style}></div>
      </div>

      <div className={classes["bonus-content-wrapper"]}>
        <div className={classes["bonus-content"]}>
          <div className={classes["bonus-title"]}> {useTranslation(name)}</div>
         <div className={classes["bonus-subtitle"]}>
            {useTranslation("presstoselect")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BonusCard;
